import React from "react";
import { Loader, Button } from "rsuite";
import MinCloseIcon from "@rsuite/icons/Close";
import { useNavigate } from "react-router-dom";
import { Radio, RadioGroup, Form } from "rsuite";

import AuthService from "../../services/auth.service";
import RegimeType from "../panel/regime_type/regimeType";

import CloseIcon from "../../img/close_red.svg";
import VoucherIcon from "../../img/voucher_icon.svg";
import TicIcon from "./../../../src/img/tick-square.svg";

import "./subscriptionPackage.scss";
import "react-toastify/dist/ReactToastify.css";

export const SubscriptionPackageForm = ({
  disableDiets,
  activeDiet,
  handleChange,
  activeDiets,
  selectedSubscriptionPackage,
  handleOnChangeSubscriptionPackage,
  shadow,
  activeCodeGroup,
  isActive,
  isActiveText,
  isCheckingVoucher,
  subscriptionPackageFinalPrice,
  subscriptionPackageFinalPriceText,
  messageType,
  code,
  setCode,
  voucherAccept,
  resetInput,
  isLoading,
  save,
  buttonStatus,
  applyVoucher,
  removeCode,
  message,
  messageClass,
  submitButtonText,
  helps,
  buttonContent,
}) => {
  const navigate = useNavigate();

  const user = AuthService.getCurrentUser()?.user;
  const isForeign = user?.is_foreign;

  const currency = selectedSubscriptionPackage?.currency.title
    ? selectedSubscriptionPackage?.currency.title
    : activeDiet?.subscription_packages.length > 0
    ? activeDiet?.subscription_packages[0]?.currency.title
    : "";
  const currencyType = selectedSubscriptionPackage?.currency.type
    ? selectedSubscriptionPackage?.currency.type
    : activeDiet?.subscription_packages.length > 0
    ? activeDiet?.subscription_packages[0]?.currency.type
    : "";

  function number_format(number, decimals, dec_point, thousands_sep) {
    // Strip all characters but numerical ones.
    number = (number + "").replace(/[^0-9+\-Ee.]/g, "");
    var n = !isFinite(+number) ? 0 : +number,
      prec = !isFinite(+decimals) ? 0 : Math.abs(decimals),
      sep = typeof thousands_sep === "undefined" ? "," : thousands_sep,
      dec = typeof dec_point === "undefined" ? "." : dec_point;

    // Format the number based on rounding condition
    var s;
    if (currencyType === "IRR") {
      // Round to the specified precision
      s = n.toFixed(prec).split(".");
    } else {
      // Preserve the exact decimal part without rounding
      s = n.toFixed(2).toString().split(".");
      if (prec > 0 && s[1]) {
        s[1] = s[1].substring(0, prec); // Truncate to `prec` decimal places
      }
    }

    // Add thousands separator to the integer part
    if (s[0].length > 3) {
      s[0] = s[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, sep);
    }

    // Pad the decimal part with zeros if needed
    if (prec > 0) {
      s[1] = (s[1] || "").padEnd(prec, "0");
    }

    return s.join(dec);
  }

  function priceFormat(value) {
    return number_format(value);
  }

  const validate = () => {
    return code.length;
  };

  return (
    <Form>
      <div className="form-header">
        <div className="close-page " onClick={(e) => navigate("/")}>
          <MinCloseIcon />
        </div>
      </div>

      <div className="packages-type">
        <div className="form-header">
          <div className="close-page" onClick={(e) => navigate("/")}>
            <MinCloseIcon />
          </div>
          <div className="form-title">انتخاب نوع رژیم</div>
        </div>
        <RegimeType
          activeDiets={activeDiets}
          disableDiets={disableDiets}
          activeDiet={activeDiet}
          handleChange={handleChange}
          handleClose={(e) => navigate("/")}
        />
      </div>

      <div className="packages-item">
        <div className="form-title">انتخاب برنامه</div>
        <div className="subscription-package-target"></div>
        <RadioGroup
          name="subscription-package"
          value={
            selectedSubscriptionPackage ? selectedSubscriptionPackage.id : null
          }
        >
          {activeDiet?.subscription_packages?.map(
            (subscriptionPackage, subscriptionPackageIndex) => {
              return (
                <Radio
                  className={`d-block subscription-package-item   shadow-normal ${
                    shadow === subscriptionPackage.id
                      ? "new-box-shadow"
                      : "shadow"
                  }`}
                  appearance="default"
                  style={{ marginLeft: 0 }}
                  value={subscriptionPackage.id}
                  onChange={(e) =>
                    handleOnChangeSubscriptionPackage(subscriptionPackage)
                  }
                  key={subscriptionPackageIndex}
                >
                  <div className="option-title">
                    {subscriptionPackage.title}
                  </div>
                  <div className="option-content">
                    {subscriptionPackage.target_title}
                  </div>

                  <div className="option-pricing">
                    <div className="off-percentage">
                      {subscriptionPackage.off_price &&
                        subscriptionPackage?.show?.off_price === "show" && (
                          <>
                            <div
                              className={`percentage ${
                                currencyType !== "IRR" && "font-mono"
                              }`}
                            >
                              {
                                priceFormat(
                                  100 -
                                    (subscriptionPackage.off_price * 100) /
                                      subscriptionPackage.price
                                ).split(".")[0]
                              }
                              %
                            </div>
                            <div className="label">تخفیف</div>
                          </>
                        )}
                      {!subscriptionPackage?.off_price && (
                        <>
                          <div className="no-off-label">
                            بدون
                            <br />
                            تخفیف
                          </div>
                        </>
                      )}
                    </div>
                    <div className="prices">
                      <div
                        className={`final-price flex gap-1 ${
                          currencyType !== "IRR" && "font-mono"
                        }`}
                      >
                        {subscriptionPackage.off_price
                          ? priceFormat(subscriptionPackage.off_price)
                          : priceFormat(subscriptionPackage.price).split(
                              "."
                            )[0]}{" "}
                        {currencyType === "IRR" ? currency : currencyType}
                      </div>
                      {subscriptionPackage?.off_price &&
                        subscriptionPackage?.show?.price === "show" && (
                          <div
                            className={`real-price ${
                              currencyType !== "IRR" && "font-mono"
                            }`}
                          >
                            {
                              priceFormat(subscriptionPackage.price).split(
                                "."
                              )[0]
                            }{" "}
                            {currencyType === "IRR" ? currency : currencyType}
                          </div>
                        )}
                    </div>
                  </div>
                </Radio>
              );
            }
          )}
        </RadioGroup>
        <div className="voucher-div">
          <div className="voucher">
            <div className="section-group shadow-normal">
              <div className="overlap">
                <div className="question-group">
                  <img className="vector" alt="Vector" src={VoucherIcon} />
                  <div className="voucher-text">{isActiveText}</div>
                </div>
                <button
                  className={
                    isActive
                      ? "enter-code-disabled"
                      : `enter-code ${
                          isForeign &&
                          "cursor-default !text-[#cecccc] !border-solid !border-[#cecccc]"
                        }`
                  }
                  onClick={activeCodeGroup}
                >
                  وارد کردن کد
                </button>
              </div>
              <div
                className={
                  `code-group ${isCheckingVoucher ? "has-loader" : ""}` +
                  " " +
                  (isActive ? "expanded " : "collapsed ") +
                  messageType
                }
              >
                <input
                  type="text"
                  className={`${voucherAccept ? "voucher-code" : ""}`}
                  placeholder="کد تخفیف را اینجا وارد کنید"
                  name="code"
                  value={code}
                  onChange={(e) => setCode(e.target.value)}
                  onKeyUp={resetInput}
                />

                {buttonStatus || isCheckingVoucher ? (
                  <button
                    className={validate() ? "submit" : ""}
                    disabled={!validate()}
                    onClick={(e) => applyVoucher(selectedSubscriptionPackage)}
                  >
                    <span className="button-text">ثبت</span>
                    <Loader className="voucher-loader" speed="fast" />
                  </button>
                ) : (
                  <button
                    className={`delete ${voucherAccept ? "delete-text" : ""}`}
                    onClick={removeCode}
                  >
                    {buttonContent === "حذف" ? (
                      "حذف"
                    ) : (
                      <img
                        className="closeIcon"
                        alt="CloseIcon"
                        src={CloseIcon}
                      />
                    )}
                  </button>
                )}
              </div>

              {message && (
                <div className="alert-message">
                  <p className={messageClass}> {message} </p>
                </div>
              )}
            </div>
          </div>
        </div>

        <div className="form-footer">
          <div className="form-footer-container">
            <div className="price-container">
              <div className="title tar">مبلغ قابل پرداخت</div>
              <div
                className={`amount ${currencyType !== "IRR" && "font-mono"}`}
                style={{ marginTop: "0.5rem" }}
              >
                {subscriptionPackageFinalPrice > 0
                  ? `${number_format(subscriptionPackageFinalPrice)} ${
                      currencyType === "IRR" ? currency : currencyType
                    }`
                  : "..."}
              </div>
              <div
                className="amount amount-text"
                style={{ marginTop: "0.5rem" }}
              >
                {subscriptionPackageFinalPrice > 0
                  ? `${subscriptionPackageFinalPriceText} ${currency}`
                  : subscriptionPackageFinalPrice === 0
                  ? subscriptionPackageFinalPriceText
                  : "..."}
              </div>
            </div>
            <div
              className="save-button-container"
              style={{ marginTop: "1rem" }}
            >
              <Button
                appearance={isLoading ? "default" : "primary"}
                loading={isLoading}
                onClick={save}
                block
              >
                <b style={{ color: "#fff" }}>{submitButtonText}</b>
              </Button>
            </div>
          </div>
        </div>

        <div className="help-text">
          <div>چرا از چنگال رژیم بگیریم؟</div>
          <ul>
            {helps?.map((help, helpIndex) => (
              <li key={helpIndex}>
                <img className="tick-icon" src={TicIcon} alt="tic" />
                {help}
              </li>
            ))}
          </ul>
        </div>
      </div>
    </Form>
  );
};
